import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { connect } from "react-redux";
import { SelectInput } from "components/HookFormComponents/SelectInput";
import { useIntl } from "react-intl";

function DisplayPictoForm({ display, displays, disabled }) {
  const intl = useIntl();
  const currentPicto = useMemo(
    () =>
      displays?.find(
        (d) => d.id === display?.children?.find((c) => c?.type === "PICTO")?.id
      ),
    [display?.children, displays]
  );

  const togglePictoForm = useMemo(
    () => currentPicto?.available_colors?.length > 0,
    [currentPicto]
  );

  return (
    <>
      {togglePictoForm && (
        <Box sx={{ mt: 2 }}>
          <SelectInput
            name="rule.pictogram"
            label={intl.formatMessage({ id: "displaysScene.picto" })}
            items={currentPicto?.available_colors?.map((c) => ({
              label: intl.formatMessage({
                id: `displaysScene.pictoColors.${c.name}`,
              }),
              value: c.symbol,
            }))}
            sx={{ width: "100%" }}
            disabled={disabled}
          />
        </Box>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  displays: state.Displays.list.items,
});

export default connect(mapStateToProps)(DisplayPictoForm);
